var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tabledata)?_c('table-component',{attrs:{"enable-column-filter":true,"columns":_vm.tableColumns,"table-data":_vm.tabledata,"rowsClickable":true},on:{"rowClick":_vm.handleRowClick}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }